/*
 * HISTORY TOGGLE (F5) — loads one record's audit history on demand. Read-only. Actor emails
 * arrive only for the Owner; everyone else sees role and time.
 */
import { useState } from "react";
import axios from "axios";

export const HistoryToggle = ({ url, testId, describe }) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const toggle = async () => {
    if (open) { setOpen(false); return; }
    setOpen(true);
    try {
      const res = await axios.get(url);
      setData(res.data);
      setError(null);
    } catch (e) {
      setError("History could not be read.");
    }
  };

  return (
    <div style={{ marginTop: 6 }}>
      <button className="fc-btn fc-btn--ghost" style={{ padding: "2px 10px", fontSize: 12 }}
        onClick={toggle} data-testid={`${testId}-toggle`}>
        {open ? "Hide history" : "History"}
      </button>
      {open && (
        <ul style={{ margin: "8px 0 0", paddingLeft: 16, fontSize: 12, opacity: 0.85 }} data-testid={`${testId}-list`}>
          {error && <li data-testid={`${testId}-error`}>{error}</li>}
          {data && !(data.history || []).length && <li>No recorded changes.</li>}
          {(data?.history || []).map((h, i) => (
            <li key={`${h.at}-${i}`} data-testid={`${testId}-entry-${i}`}>
              {(h.at || "").slice(0, 16).replace("T", " ")} · {h.actor_email || h.role} · {describe(h)}
            </li>
          ))}
          {data && <li style={{ opacity: 0.6 }}>Newest first, at most {data.limit}.</li>}
        </ul>
      )}
    </div>
  );
};
